import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const SuccessOrder = ({ location }) => {
  const { pathname } = location;
  const { id } = useParams()

  return (
    <Fragment>
      <MetaTags>
        <title>JT Hanna | Success</title>
        <meta
          name="description"
          content="Success"
        />
      </MetaTags>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Success Order
      </BreadcrumbsItem>
      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb />
        <div className="error-area" style={{ paddingBottom: 100 }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-lg-8 text-center">
                <div className="error">
                  <div><img src={`/assets/img/success.gif?v=${new Date().getMinutes()}`} /></div>
                  <h2>Success!</h2>
                  <h2>Thank you for your purchase.</h2>
                  <p>
                    {`Your order ID is #${id} if you wish to continue please click to home page button.`}
                  </p>
                  <Link to={process.env.PUBLIC_URL + "/"} className="error-btn" style={{ color: 'white'}}>
                    Back to Home Page
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

SuccessOrder.propTypes = {
  location: PropTypes.object
};

export default SuccessOrder;
